import { Button } from '@ipfabric/ui-components/Button/Button';
import { type FC, memo } from 'react';
import { CustomPortSettings } from './CustomPortSettings';
import type { CustomPortSettingsModel } from './useCustomPortSettings';

interface Props {
  model: CustomPortSettingsModel;
}

const BareCustomPortSettingsWithModel: FC<Props> = ({ model }) => {
  return (
    <>
      <CustomPortSettings
        commands={model.commands}
        confirmDialog={model.confirmDialog}
        customPortSettingsIndexed={model.customPortSettingsIndexed}
        showables={model.showables}
        borderless={false}
        tableClassName='flex-1 bg-transparent'
        menuItems={[
          {
            standalone: true,
            elementWithKey: (
              <Button
                key='add-new'
                variant='outline'
                size='small'
                icon='fa-plus-circle'
                onClick={() => {
                  model.showables.addSetting.show();
                }}
              >
                Add new
              </Button>
            ),
          },
        ]}
      />
      {model.confirmDialog.render()}
    </>
  );
};

export const CustomPortSettingsWithModel = memo(
  BareCustomPortSettingsWithModel,
);
